export { customLocalStore as store } from './reducers'
